import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { MdClose } from 'react-icons/md'

import Text from '../Text/Text'
import styles from './tag.module.scss'

const Tag = ({
  active,
  width,
  white,
  text,
  id,
  size,
  outlined,
  small,
  Icon,
  onClick,
  onClose,
  quantity,
  disabled
}) => {
  const tagClass = classNames(styles.tag, {
    [styles.active]: active,
    [styles.white]: !active && white,
    [styles.outlined]: outlined,
    [styles.small]: small,
    [styles.disabled]: disabled
  })

  const textClasses = classNames(styles.text, {
    [styles.active]: active
  })

  const tagStyles = {}

  if (width) tagStyles.width = width

  return (
    <div
      className={tagClass}
      style={tagStyles}
      onClick={() => onClick && onClick({ id, text })}
    >
      {quantity > 0 && <div className={styles.quantity}>{quantity}</div>}
      <Text size={size} font="custom" className={textClasses}>
        {text}
      </Text>
      {onClose && (
        <button type="button" onClick={() => onClose()}>
          <MdClose color={active ? 'white' : '#737373'} />
        </button>
      )}
      {Icon && <Icon />}
    </div>
  )
}

Tag.defaultProps = {
  active: false,
  width: null,
  onClose: null,
  Icon: null,
  onClick: null,
  white: null,
  size: 'xxs',
  id: null,
  outlined: false,
  small: false,
  quantity: null,
  disabled: false
}

Tag.propTypes = {
  active: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  width: PropTypes.string,
  white: PropTypes.bool,
  onClose: PropTypes.func,
  text: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  Icon: PropTypes.func,
  size: PropTypes.string,
  outlined: PropTypes.bool,
  small: PropTypes.bool,
  onClick: PropTypes.func,
  quantity: PropTypes.number,
  disabled: PropTypes.bool
}

export default Tag
